import { h } from "preact";

import { getValue } from "../../helpers.js";
import i18n from "../../i18n";
import loadingProductHoc from "../../hocs/loadingProductHoc.jsx";

import Button from "../Button.jsx";
import HeaderIcon from "../HeaderIcon.jsx";
import Icon from "../Icon.jsx";
import List from "../List.jsx";
import ListItem from "../ListItem.jsx";
import TaskLink from "../TaskLink.jsx";

export default {
  visa_application_start: loadingProductHoc(
    "visa_check",
    ({ product, onNext }) => {
      return (
        <section class="task-page">
          <h1 class="task-page__headline">Visa application</h1>

          <div class="task-page__content">
            <p>
              Please submit your application to the diplomatic mission in your
              country of residence.
            </p>

            <List class="mb-32">
              <ListItem number={1}>
                Schedule a visa interview at the diplomatic mission.
                <TaskLink id="diplomatic_mission" class="ml-16" />
                <TaskLink id="diplomatic_mission_full" class="ml-16" />
              </ListItem>
              <ListItem number={2}>
                Show up on time with the required documents.
                <TaskLink id="visa_documents" class="ml-16" />
              </ListItem>
              <ListItem number={3}>
                Apply for a{" "}
                <em>
                  {product ? i18n.t(`products.${product.id}.title`) : "visa"}
                </em>
                .
              </ListItem>
              <ListItem number={4}>Keep your visa in a safe place.</ListItem>
            </List>

            <p>
              Has the embassy approved your visa application? Please pass this
              information on to Nioomi.
            </p>
          </div>

          <div class="task-page__buttons">
            <Button onClick={onNext}>{i18n.t("actions.enter_result")}</Button>
          </div>
        </section>
      );
    }
  ),
  visa_application_result: loadingProductHoc(
    "visa_check",
    ({ product, answers, onClose, onNext, onRestart }) => {
      const success = getValue(answers.outcomeVisaApplication);

      return (
        <section class="task-page">
          <HeaderIcon>visa_application</HeaderIcon>
          <h1 class="task-page__headline">
            {i18n.t("pages.common.result_title")}
          </h1>

          <div class="task-page__content">
            <p>
              <Icon>{success ? "check" : "warning"}</Icon>
            </p>
            <List class="mb-32">
              {success ? (
                <ListItem overline="Visa">
                  Your application for a{" "}
                  <em>
                    {product ? i18n.t(`products.${product.id}.title`) : "visa"}
                  </em>{" "}
                  was successful.
                </ListItem>
              ) : (
                <ListItem overline="Visa">
                  Your application for a{" "}
                  <em>
                    {product ? i18n.t(`products.${product.id}.title`) : "visa"}
                  </em>{" "}
                  was denied.
                </ListItem>
              )}
            </List>
          </div>

          <div class="task-page__buttons">
            {success ? (
              <Button onClick={onNext}>{i18n.t("actions.done")}</Button>
            ) : (
              <Button onClick={onClose}>{i18n.t("actions.ok")}</Button>
            )}
            <Button text onClick={onRestart}>
              {i18n.t("actions.discard_result")}
            </Button>
          </div>
        </section>
      );
    }
  ),
};
